<template>
  <div class="container-fluid">
    <route-header>
      <h3>{{ $tc('labels.project', 0) }}</h3>
    </route-header>
    <div class="row mb-4">
      <div class="col-12">
        <my-projects />
      </div>
    </div>
    <route-header>
      <h3>{{ $t('labels.nav.todays_assignments') }}</h3>
    </route-header>
    <div class="row">
      <div class="col-12">
        <my-schedule-today />
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data () {
    return {
      email: ''
    }
  },
  created () {
    this.$store.dispatch('showUser')
  }
}
</script>
